'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../lib/utils';

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          'z-50 overflow-hidden rounded-md bg-gray-900 px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };

// 'use client';

//
// import * as React from 'react';
// import * as TooltipPrimitive from '@radix-ui/react-tooltip';
//
// import { cn } from '../lib/utils';
//
// type PrimitiveRootProps = React.ComponentPropsWithoutRef<
//   typeof TooltipPrimitive.Root
// >;
//
// type PrimitiveRootElement = React.ElementRef<TooltipPrimitive.Root>;
//
// const Tooltip = React.forwardRef<PrimitiveRootElement, PrimitiveRootProps>(
//   ({ delayDuration = 0, ...props }) => (
//     <TooltipPrimitive.Provider delayDuration={delayDuration}>
//       <TooltipPrimitive.Root {...props} />
//     </TooltipPrimitive.Provider>
//   ),
// );
//
// Tooltip.displayName = TooltipPrimitive.Root.displayName;
//
// const TooltipTrigger = TooltipPrimitive.Trigger;
//
// const TooltipContent = React.forwardRef<
//   React.ElementRef<typeof TooltipPrimitive.Content>,
//   React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
// >(({ className, sideOffset = 4, ...props }, ref) => {
//   return (
//     <TooltipPrimitive.Content
//       ref={ref}
//       sideOffset={sideOffset}
//       className={cn(
//         'z-50 overflow-hidden rounded-md bg-gray-900 px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
//         className,
//       )}
//       {...props}
//     />
//   );
// });
// TooltipContent.displayName = TooltipPrimitive.Content.displayName;
//
// export { Tooltip, TooltipTrigger, TooltipContent };
